import "./OnlineMenuStartupPage.scss";
import { useNavigate } from "react-router-dom";
import { routes } from "../../__product__/navigation/routes";
import SwipeableViews from "react-swipeable-views";
import { autoPlay } from "react-swipeable-views-utils";
import OnlineMenuStartupHook from "./OnlineMenuStartupHook";
import { getImage } from "../../api/ApiPath";
import LanguageIcon from "@mui/icons-material/Language";
import Paper from "@mui/material/Paper";
import InputBase from "@mui/material/InputBase";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import { useTranslation } from "react-i18next";
import TelescopeImage from "../../components/atom/image/TelescopeImage";
import { FoodsObj } from "../../api/model/response/OnlineMenuResponseModel";
import { Card, CardMedia } from "@mui/material";
import OnlineMenuService, { StatisticIdentifiers } from "../../api/service/OnlineMenuService";
import LoadingPage from "../../components/experience/loading/LoadingPage";
import TelescopePopover from "../../components/atom/pop_over/TelescopePopover";
import i18n from "../../__product__/language/i18n";
import AnnouncementModal from "../../components/experience/announcementModal/AnnouncementModal";
import { ShoppingCart } from "@mui/icons-material";
import { useUserContext } from "../../context/UserContext";
import AddToCartIcon from "../../components/experience/addToCartIcon/addToCartIcon";
import { useEffect, useState } from "react";
import { useMyNavigate } from "../../__product__/navigation/myNavigate";

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

const OnlineMenuStartupPage = () => {
  const {
    isLoading,
    currentOnlineMenu,
    currentCompanyInfo,
    setSearchValue,
    searchValue,
    foundedFoodList,
    currentLanguagesList,
    setSearchIsFocused,
    searchBoxRef,
    showAnnouncement,
    setShowAnnouncement
  } = OnlineMenuStartupHook();
  const navigate = useMyNavigate();
  const { t } = useTranslation();
  const { statisticRequest, getOnlineMenu, getOnlineMenuCompanyInformation } = OnlineMenuService();

  const { orders, isCartActive, setOrders } = useUserContext();
  const [isPressed, setIsPressed] = useState<string>("");

  useEffect(() => {
    if (currentOnlineMenu?.title) return;
  }, [currentOnlineMenu]);

  function renderSearchArea() {
    function handleSearchFocused() {
      setSearchIsFocused(true);
    }
    function handleSearchBlur() {
      setSearchIsFocused(false);
    }

    return (
      <Paper elevation={0} component="form" className={"input-base-area"}>
        <InputBase
          ref={searchBoxRef}
          sx={{ ml: 1, flex: 1 }}
          placeholder={t("search_food") ?? ""}
          inputProps={{ "aria-label": t("search_food") ?? "" }}
          value={searchValue}
          onFocus={handleSearchFocused}
          onBlur={handleSearchBlur}
          onChange={(event) => {
            setSearchValue(event.target.value);
          }}
        />
        <IconButton type="button" sx={{ p: "10px" }}>
          <SearchIcon />
        </IconButton>
      </Paper>
    );
  }

  function renderCategories() {
    return (
      <div className="image-list">
        {currentOnlineMenu.categoriesObj?.map((category, index) => (
          <div
            role={"button"}
            onClick={() => {
              void statisticRequest({
                url: window.location.pathname,
                objId: category.id,
                onlineMenuId: currentOnlineMenu.id,
                identifier: StatisticIdentifiers.CATEGORY_DETAIL_VIEW
              });
              navigate(`${routes.food}/${category.id}`);
            }}
            key={index}
            className="image-list-item"
          >
            {category.photoUrl ? (
              <img src={getImage(category.photoUrl)} alt={`Image ${index}`} />
            ) : (
              <TelescopeImage image={"free-png"} />
            )}
            <div className="image-overlay">
              <div className="image-name">{`${category.title}`}</div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  function getFavouriteFoods() {
    const foods: Array<FoodsObj> = [];
    currentOnlineMenu.categoriesObj.forEach((category) => {
      category?.foodsObj?.forEach((food) => {
        if (food.foodTagsObj?.some((tag) => tag.foodTagType === 2)) foods.push(food);
      });
    });
    return foods;
  }

  function getCampaignFoods() {
    const foods: Array<FoodsObj> = [];
    currentOnlineMenu.categoriesObj.forEach((category) => {
      category?.foodsObj?.forEach((food) => {
        if (food.foodTagsObj?.some((tag) => tag.foodTagType === 3)) foods.push(food);
      });
    });
    return foods;
  }

  function getTotalNumberOfOrder() {
    let ret = 0;
    orders.forEach((order) => {
      ret += order.quantity;
    });
    return ret;
  }

  function renderFoodObj(food: FoodsObj, categoryId: string, isFoodDetail = false, isSubfood = false) {
    const allergens = food.ingredientsObj?.filter((x) => x.isAllergen === 1);
    const ingredients = food.ingredientsObj?.filter((x) => x.isAllergen === 0);
    return (
      <Card role={"button"} onClick={() => {}} className={"panel-item"} elevation={0}>
        <div className={"food-tags"}>
          {food.foodTagsObj?.map((tag, i) => {
            return (
              <div
                style={{
                  backgroundColor: currentOnlineMenu.otherColor ?? "var(--helper-danger-900)",
                  color: currentOnlineMenu?.titleColor ?? "white"
                }}
                className={"item"}
                key={i}
              >
                {`${tag.title}`}
              </div>
            );
          })}
        </div>
        {isFoodDetail && ingredients && (
          <div className={"iyilestir-subtitle-medium"}>{ingredients.length > 0 ? t("ingredients") : ""}</div>
        )}
        {isFoodDetail && (
          <div className={"ingredients-area"}>
            {ingredients?.map((value, i) => {
              return (
                <div className={"iyilestir-caption"} key={i}>
                  {value.title}
                </div>
              );
            })}
          </div>
        )}
        {isFoodDetail && allergens && (
          <div className={"iyilestir-subtitle-medium"}>{allergens?.length > 0 ? t("allergens") : ""}</div>
        )}
        {isFoodDetail && (
          <div className={"ingredients-area"}>
            {allergens?.map((value, i) => {
              return (
                <div className={"iyilestir-caption"} key={i}>
                  {value.title}
                </div>
              );
            })}
          </div>
        )}
        {food?.photoUrl && <CardMedia component="img" height="192" image={getImage(food?.photoUrl)} alt={food.title} />}
        <div className={"price-title-area"}>
          <div className={"iyilestir-secondary-button"}>{food?.title}</div>
          <div className="price-plus-area2">
            <div className={"price-area"}>
              {(isCartActive ? food?.orderPrice : food.price) && (
                <div
                  className={`iyilestir-subtitle-bold ${food.discountedPrice !== null && !isCartActive && "old-price"}`}
                >{`${currentOnlineMenu.currecyTitle}${isCartActive ? food?.orderPrice : food.price}`}</div>
              )}
              {!isCartActive && food?.discountedPrice && (
                <div
                  className={`iyilestir-subtitle-bold`}
                >{`${currentOnlineMenu.currecyTitle}${food?.discountedPrice}`}</div>
              )}
            </div>
            <AddToCartIcon
              food={food}
              type={isSubfood ? "subfood" : "food"}
              isPressed={isPressed}
              setIsPressed={setIsPressed}
              categoryId={categoryId}
            />
          </div>
        </div>
        <div className={"iyilestir-caption"}>{food?.description}</div>
        {food?.warningText && <div className={"warning-text"}>{food?.warningText}</div>}
        {food?.subFoodsObj?.map((value) => {
          return renderFoodObj(value, categoryId, isFoodDetail, true);
        })}
      </Card>
    );
  }

  return (
    <>
      <head>
        <title>{currentCompanyInfo ? currentCompanyInfo?.title : "menu"}</title>
        <meta name="description" content={currentOnlineMenu ? currentOnlineMenu?.description : "Online Menü"} />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="icon" href="/menu/favicon.ico" />
      </head>
      <main style={{ backgroundColor: currentOnlineMenu?.backgroundColor ?? "white" }}>
        {isLoading ? (
          <LoadingPage />
        ) : (
          <div className={"startup-root"}>
            <AnnouncementModal
              isOpen={showAnnouncement}
              onClose={() => {
                setShowAnnouncement(false);
              }}
            />
            {currentOnlineMenu?.photoUrlsObj && (
              <AutoPlaySwipeableViews>
                {currentOnlineMenu.photoUrlsObj
                  ?.filter((value) => value.photoUrl)
                  .map((imageUrl, index) => (
                    <div key={index}>
                      {imageUrl && (
                        <img className={"slider-image"} src={getImage(imageUrl.photoUrl)} alt={`Image ${index}`} />
                      )}
                    </div>
                  ))}
              </AutoPlaySwipeableViews>
            )}
            <div className={"startup-body-root"}>
              {currentOnlineMenu?.categoriesObj?.map((value) => {
                return value.foodsObj?.find((value1) => value1.foodTagsObj?.some((value2) => value2.foodTagType === 2));
              }) &&
                getFavouriteFoods()?.length > 0 && (
                  <div className={"margin-vertical-16"}>
                    <div className={"iyilestir-subtitle-bold"}>{`${t("favorites")}`}</div>
                    <div className={"favorite-list"}>
                      {currentOnlineMenu?.categoriesObj &&
                        getFavouriteFoods().map((food, i) => {
                          return !food ? (
                            <div></div>
                          ) : (
                            <div
                              role={"button"}
                              onClick={() => {
                                void statisticRequest({
                                  // TODO : statistic
                                  url: window.location.pathname,
                                  objId: food.id,
                                  onlineMenuId: currentOnlineMenu.id,
                                  identifier: StatisticIdentifiers.FOOD_DETAIL_VIEW
                                });
                              }}
                            >
                              <TelescopePopover
                                buttonClassName={"popover-button-classname"}
                                key={i}
                                closeIcon
                                popOverContent={
                                  <div className={"home-tab-panel with-popover"}>
                                    {food &&
                                      renderFoodObj(
                                        food,
                                        currentOnlineMenu?.categoriesObj.find((c) =>
                                          c.foodsObj?.find((f) => f.id === food.id)
                                        )?.id ?? "",
                                        true
                                      )}
                                  </div>
                                }
                                anchorOrigin={{
                                  vertical: "top",
                                  horizontal: "left"
                                }}
                              >
                                <div key={i} className={"favorite-item"}>
                                  {food?.photoUrl ? (
                                    <img className={"img"} src={getImage(food.photoUrl)} alt={"food"} />
                                  ) : (
                                    <TelescopeImage className={"img"} image={"default_image"} />
                                  )}
                                  <div className={"iyilestir-caption"}>{food?.title}</div>
                                </div>
                              </TelescopePopover>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                )}
              {currentOnlineMenu?.categoriesObj?.map((value) => {
                return value.foodsObj?.find((value1) => value1.foodTagsObj?.some((value2) => value2.foodTagType === 3));
              }) &&
                getCampaignFoods()?.length > 0 && (
                  <div className={"margin-vertical-16"}>
                    <div className={"iyilestir-subtitle-bold"}>{`${t("campaign")}`}</div>
                    <div className={"favorite-list"}>
                      {currentOnlineMenu?.categoriesObj &&
                        getCampaignFoods().map((food, i) => {
                          return !food ? (
                            <div></div>
                          ) : (
                            <div
                              role={"button"}
                              onClick={() => {
                                void statisticRequest({
                                  // TODO : statistic
                                  url: window.location.pathname,
                                  objId: food.id,
                                  onlineMenuId: currentOnlineMenu.id,
                                  identifier: StatisticIdentifiers.FOOD_DETAIL_VIEW
                                });
                              }}
                            >
                              <TelescopePopover
                                buttonClassName={"popover-button-classname"}
                                key={i}
                                closeIcon
                                popOverContent={
                                  <div className={"home-tab-panel with-popover"}>
                                    {food &&
                                      renderFoodObj(
                                        food,
                                        currentOnlineMenu?.categoriesObj.find((c) =>
                                          c.foodsObj?.find((f) => f.id === food.id)
                                        )?.id ?? "",
                                        true
                                      )}
                                  </div>
                                }
                                anchorOrigin={{
                                  vertical: "top",
                                  horizontal: "left"
                                }}
                              >
                                <div key={i} className={"campaign-item"}>
                                  {food?.photoUrl ? (
                                    <img className={"img"} src={getImage(food.photoUrl)} alt={"food"} />
                                  ) : (
                                    <TelescopeImage className={"img"} image={"default_image"} />
                                  )}
                                  <div className={"iyilestir-caption"}>{food?.title}</div>
                                </div>
                              </TelescopePopover>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                )}
              {currentCompanyInfo?.announcementObj && (
                <>
                  {/* <div className={"iyilestir-subtitle-bold"}>
                    {`${t("announcement")}`}
                  </div> */}
                  <div className={"announcement-area"} style={{ backdropFilter: "brightness(1.05)" }}>
                    {currentCompanyInfo?.announcementObj &&
                      currentCompanyInfo?.announcementObj?.filter(
                        (value) => value.title !== null && value.title !== undefined
                      ).length > 0 && (
                        <AutoPlaySwipeableViews>
                          {currentCompanyInfo?.announcementObj
                            ?.filter((value) => value.photoUrl === null && value.title)
                            .map((value, i) => {
                              return (
                                <div key={i} className={"item"}>
                                  {/* <div>
                            {value.photoUrl ? (
                              <img
                                src={getImage(value.photoUrl)}
                                alt={`Image ${i}`}
                              />
                            ) : (
                              <TelescopeImage image={"default_image"} />
                            )}
                          </div> */}
                                  {/* Change to photo */}
                                  {
                                    <div>
                                      {value.title && (
                                        <div
                                          className={"title"}
                                          style={{ color: currentOnlineMenu?.otherColor ?? "dodgerblue" }}
                                        >
                                          {value.title}
                                        </div>
                                      )}
                                      {value.description && (
                                        <div
                                          className={"description"}
                                          style={{ color: currentOnlineMenu.titleColor ?? "black" }}
                                        >
                                          {value.description}
                                        </div>
                                      )}
                                      {value.announcement && (
                                        <div
                                          className={"announcement"}
                                          style={{ color: currentOnlineMenu.titleColor ?? "black" }}
                                        >
                                          {value.announcement}
                                        </div>
                                      )}
                                    </div>
                                  }
                                </div>
                              );
                            })}
                        </AutoPlaySwipeableViews>
                      )}
                  </div>
                </>
              )}
              <div className={"startup-translation-area"}>
                <div className={"iyilestir-subtitle-bold"}>
                  {currentCompanyInfo?.instagram ? (
                    <a
                      className={"instagram-bar"}
                      href={currentCompanyInfo?.instagram}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <TelescopeImage className={"img"} image={"insta-badge"} />
                      <span className="btn-follow">{t("follow")}</span>
                    </a>
                  ) : (
                    <span>{currentCompanyInfo?.title}</span>
                  )}
                </div>
                <TelescopePopover
                  autoDismiss
                  popOverContent={
                    <div style={{ width: "initial" }}>
                      {currentLanguagesList?.map((value, index) => {
                        return (
                          <div
                            role={"button"}
                            onClick={() => {
                              void i18n.changeLanguage(value.language).then(() => {
                                void getOnlineMenu();
                                void getOnlineMenuCompanyInformation();
                              });
                            }}
                            key={index}
                            className={"language-list-area"}
                          >
                            <img className={"flag"} src={getImage(value.photoUrl)} alt={"photo"} />
                            <div>{value.description}</div>
                          </div>
                        );
                      })}
                    </div>
                  }
                >
                  <div className={"language-icon"}>
                    <LanguageIcon className={"icon"} style={{ color: currentOnlineMenu.otherColor }} />
                  </div>
                </TelescopePopover>
                {isCartActive && (
                  <button className="cart-button" onClick={() => navigate(routes.cart)}>
                    <ShoppingCart className="icon" />
                    <span className="order-count">{getTotalNumberOfOrder()}</span>
                  </button>
                )}
              </div>
              {renderSearchArea()}
              {searchValue === "" ? (
                renderCategories()
              ) : (
                <div className={"home-tab-panel"}>
                  {foundedFoodList.length > 0 &&
                    foundedFoodList?.map((food, i) => {
                      return (
                        <div key={i}>
                          {renderFoodObj(
                            food,
                            currentOnlineMenu?.categoriesObj.find((c) => c.foodsObj?.find((f) => f.id === food.id))
                              ?.id ?? ""
                          )}
                        </div>
                      );
                    })}
                </div>
              )}
              <div className={"social-media-area"}>
                {currentCompanyInfo?.phone && (
                  <div className={"item"}>
                    <a href={`tel:${currentCompanyInfo.phone}`}>
                      <TelescopeImage className={"img"} image={"phone"} />
                    </a>
                  </div>
                )}
                {currentCompanyInfo?.facebook && (
                  <div className={"item"}>
                    <a href={currentCompanyInfo.facebook} target="_blank" rel="noreferrer">
                      <TelescopeImage className={"img"} image={"facebook"} />
                    </a>
                  </div>
                )}
                {currentCompanyInfo?.instagram && (
                  <div className={"item"}>
                    <a href={currentCompanyInfo.instagram} target="_blank" rel="noreferrer">
                      <TelescopeImage className={"img"} image={"instagram"} />
                    </a>
                  </div>
                )}
                {currentCompanyInfo?.googleMaps && (
                  <div className={"item"}>
                    <a href={currentCompanyInfo.googleMaps} target="_blank" rel="noreferrer">
                      <TelescopeImage className={"img"} image={"google_maps"} />
                    </a>
                  </div>
                )}
                {currentCompanyInfo?.twitter && (
                  <div className={"item"}>
                    <a href={currentCompanyInfo.twitter} target="_blank" rel="noreferrer">
                      <TelescopeImage className={"img"} image={"twitter"} />
                    </a>
                  </div>
                )}
              </div>
              <div className={"company-area"}>
                {currentCompanyInfo?.logoPhotoUrl && (
                  <img className={"company-photo"} src={getImage(currentCompanyInfo.logoPhotoUrl)} />
                )}
              </div>

              {currentOnlineMenu?.footerObj && (
                <div className={"footer-area"}>
                  <div className={"iyilestir-caption"}>{currentOnlineMenu?.footerObj.description}</div>
                  <div className={"copyright-area"}>
                    <div>{currentOnlineMenu?.footerObj?.copyrightText}</div>
                  </div>
                  {currentOnlineMenu?.footerObj?.footerLogo && (
                    <img
                      alt={"footer-logo"}
                      style={{ marginTop: 12 }}
                      width={72}
                      src={getImage(currentOnlineMenu?.footerObj?.footerLogo)}
                      onClick={() =>
                        currentOnlineMenu?.footerObj?.redirectLink
                          ? (window.location.href = "http://www.iyilestir.com")
                          : null
                      }
                    />
                  )}
                </div>
              )}
            </div>
          </div>
        )}
      </main>
    </>
  );
};
export default OnlineMenuStartupPage;
